
import { defineComponent, ref } from 'vue';

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true,
    },
    /** 是否需要展开收起按钮 */
    hasShow: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const isShow = ref(true);
    return {
      isShow,
    };
  },
});
